__turbopack_context__.v({
  "offer-card": "OfferCard-module-scss-module__06VbLG__offer-card",
  "offer-card-section": "OfferCard-module-scss-module__06VbLG__offer-card-section",
  "offer-card__badge": "OfferCard-module-scss-module__06VbLG__offer-card__badge",
  "offer-card__body": "OfferCard-module-scss-module__06VbLG__offer-card__body",
  "offer-card__cta": "OfferCard-module-scss-module__06VbLG__offer-card__cta",
  "offer-card__description": "OfferCard-module-scss-module__06VbLG__offer-card__description",
  "offer-card__disclaimer": "OfferCard-module-scss-module__06VbLG__offer-card__disclaimer",
  "offer-card__disclaimer-body": "OfferCard-module-scss-module__06VbLG__offer-card__disclaimer-body",
  "offer-card__disclaimer-icon": "OfferCard-module-scss-module__06VbLG__offer-card__disclaimer-icon",
  "offer-card__disclaimer-text": "OfferCard-module-scss-module__06VbLG__offer-card__disclaimer-text",
  "offer-card__disclaimer-title": "OfferCard-module-scss-module__06VbLG__offer-card__disclaimer-title",
  "offer-card__divider": "OfferCard-module-scss-module__06VbLG__offer-card__divider",
  "offer-card__header": "OfferCard-module-scss-module__06VbLG__offer-card__header",
  "offer-card__image": "OfferCard-module-scss-module__06VbLG__offer-card__image",
  "offer-card__media": "OfferCard-module-scss-module__06VbLG__offer-card__media",
  "offer-card__section-title": "OfferCard-module-scss-module__06VbLG__offer-card__section-title",
  "offer-card__title": "OfferCard-module-scss-module__06VbLG__offer-card__title",
});
